










































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'


@Component({})
class Input1TextInputForSearch extends Vue {
  @Prop({ default: '' }) label?: string
  @Prop({ default: '' }) prependIcon?: string
  @Prop({ default: '' }) appendIcon?: string
  @Prop({ default: '' }) hint?: string
  // @Prop({ default: '' }) width?: number
  @Prop({ default: false }) dense?: boolean
  @Prop({ default: false }) autofocus?: boolean
  @Prop({ default: true }) persistentHint?: boolean
  @Prop({ default: false }) hideDetails?: boolean
  @Prop({ default: false }) singleLine?: boolean
  @Prop({ default: false }) showCloseButton?: boolean
  @Prop({ default: () => function () { return Promise.resolve([]) } }) getSearchResultListCallbackFunction?: (searchText: string) => Promise<any[]>
  @Prop({ default: () => [] }) initialSearchResultList?: any
  @Prop({ default: null }) initialSelectedSearchResultId?: any
  @Prop({ default: false }) clearSearchResultAfterItemSelected?: boolean

  @Prop({ default: false }) multiple?: boolean
  @Prop({ default: () => [] }) rules?: any

  selectedSearchResultIdValue: any = ''

  autoUpdate: boolean = true
  searchText: string = ''
  isUpdatingValue: boolean = false

  searchResultList: any[] = []

  get selectedSearchResultId (): string {
    return this.selectedSearchResultIdValue
  }

  set selectedSearchResultId (resultId: string) {
    this.selectedSearchResultIdValue = resultId
  }

  @Watch('searchText') async search (searchText: string) {
    if (!searchText) { return }
    if (!this.getSearchResultListCallbackFunction) { return }
    const searchResultList = await this.getSearchResultListCallbackFunction(searchText)
    this.searchResultList = searchResultList.length > 0 ? searchResultList : this.initialSearchResultList
  }

  @Watch('isUpdatingValue') isUpdating (value: boolean) {
    if (value) {
      setTimeout(() => (this.isUpdatingValue = false), 3000)
    }
  }

  @Watch('initialSelectedSearchResultId', { deep: true }) updateInitialSelectedSearchResultId () {
    if (this.selectedSearchResultIdValue) {
      return
    }
    this.selectedSearchResultIdValue = this.initialSelectedSearchResultId
    this.emitSelectedSearchResultId()
  }

  @Watch('initialSearchResultList', { deep: true }) async updateInitialSearchResultList () {
    if (this.searchResultList.length > 0) {
      return
    }
    this.searchResultList = await this.initialSearchResultList || this.initialSearchResultList || []
  }

  async mounted () {
    await this.updateInitialSearchResultList()
    this.updateInitialSelectedSearchResultId()
  }

  remove (item: any) {
    // const index = this.friends.indexOf(item.name)
    // if (index >= 0) (this.friends || []).splice(index, 1)
    if (!this.multiple) {
      if (item.id === this.selectedSearchResultId) this.selectedSearchResultId = ''
    } else {
      const indexOfItem = this.selectedSearchResultId.indexOf(item.id)
      this.selectedSearchResultIdValue.splice(indexOfItem, 1)
    }
  }

  emitSelectedSearchResultId () {
    this.$emit('selectedSearchResultId', this.selectedSearchResultId)
    if (this.clearSearchResultAfterItemSelected) {
      //
    }
  }

/*
  descriptionLimit: number = 60
  entries: any[] = []
  isLoading: boolean = false
  model: any = null
  searchValue: any = null
  count: number = 0
*/
/*
  fields () {
    if (!this.model) return []

    return Object.keys(this.model).map(key => {
      return {
        key,
        value: this.model[key] || 'n/a'
      }
    })
  }

  get items () {
    return this.entries.map(entry => {
      const Description = entry.Description.length > this.descriptionLimit
        ? entry.Description.slice(0, this.descriptionLimit) + '...'
        : entry.Description

      return Object.assign({}, entry, { Description })
    })
  }

  @Watch('searchValue') search () {
    // Items have already been loaded
    if (this.items.length > 0) return

    // Items have already been requested
    if (this.isLoading) return

    this.isLoading = true

    // Lazily load input items
    fetch('https://api.publicapis.org/entries').then(res => res.json()).then(res => {
      const { count, entries } = res
      this.count = count
      this.entries = entries
    }).finally(() => (this.isLoading = false)).catch(err => {
      console.log(err)
    })
  }
  */
}

export default Input1TextInputForSearch
